import BaseDTO from '../base/BaseDTO';
import Detail from '../detail/Detail';
import Manufacturer from '../manufacturer/Manufacturer';
import Media from '../media/Media';
import SampleCategory from '../sample-category/SampleCategory';
import SampleLanguage from '../sample-language/SampleLanguage';
import SampleType from '../sample-type/SampleType';
import SampleBranding from '../sample-vehicle-model/SampleBranding';
import { FieldOfUse } from './FieldOfUse';
import SampleFormat from './SampleFormat';
import { SampleState } from './SampleState';

export default class Sample extends BaseDTO {

    public printedName: string | undefined;
    public fieldOfUse: FieldOfUse | undefined;
    public type: SampleType | undefined;
    public category: SampleCategory | undefined;
    public state: SampleState | undefined;
    public format: SampleFormat | undefined;
    public es2Key: string | undefined;
    public weight: number | undefined;
    public lastActivity: string | undefined;
    public lastActivityBy: string | undefined;
    public salesCodes: string[] = [];
    public availabilityDate: string | undefined;
    public expirationDate: string | undefined;
    public validTo: string | undefined;
    public manufacturer: Manufacturer | undefined;
    public sampleLanguages: SampleLanguage[] = [];
    public sspName: string | undefined;
    public categoryDetails: Detail[] = [];
    public media: Media | undefined;
    public onHold: boolean = false;
    public defaultSampleBranding: SampleBranding = SampleBranding.STANDARD;

    // Transient properties
    public detailNames: string | undefined;

    constructor(data: { [key: string]: any }) {
        super(data);
        this.printedName = data['printedName'] || undefined
        this.fieldOfUse = data['fieldOfUse'] || undefined
        this.category = data['category'] || undefined
        this.type = data['type'] || undefined
        this.state = data['state'] || undefined
        this.es2Key = data['es2Key'] || undefined
        this.weight = data['weight'] || undefined
        this.lastActivity = data['lastActivity'] || undefined
        this.lastActivityBy = data['lastActivityBy'] || undefined
        this.format = data['format'] || undefined;
        this.salesCodes = data['salesCodes'] || [];
        this.availabilityDate = data['availabilityDate'] || undefined
        this.expirationDate = data['expirationDate'] || undefined
        this.manufacturer = data['manufacturer']
            ? new Manufacturer(data['manufacturer'])
            : undefined;
        this.sampleLanguages = data['sampleLanguages'] || [];
        this.sspName = data['sspName'] || undefined;
        this.categoryDetails = data['categoryDetails'] || [];
        this.media = data['media']
            ? new Media(data['media'])
            : undefined;
        this.onHold = data['onHold'] || false;
        this.defaultSampleBranding = data['defaultSampleBranding']
            ? data['defaultSampleBranding']
            : SampleBranding.STANDARD;
        this.validTo = data['validTo'] || undefined;
    }

}